SPLIT_WORKS_WITH_OVERWRITTEN_EXEC